module.exports = "<div *ngIf=\"adBlockerDetected\" class=\"container-fuild\">\n    <div class=\"exclamation-icon item\"><i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i></div>\n    <div class=\"item\">\n        <h3 class=\"adblock-warning-title\">Le bloqueur de publicités a besoin d'être désactivé sur ce site</h3>\n        <p class=\"adblock-warning-text\">Afin de pouvoir visualiser les documents de votre requête, nous vous recommandons de désactiver ce bloqueur pour l'utilisation de ce site.</p>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/shared/components/adblocker-detector/adblocker-detector.component.html
// module id = 831
// module chunks = 0